export const countriesConfig = [
  {
    id: 'AFG',
    name: 'Afghanistan',
    countryCodeNumber: '+93',
    code: 'AF',
  },
  {
    id: 'ALI',
    name: 'Aland Islands',
    countryCodeNumber: '+358',
    code: 'AX',
  },
  {
    id: 'ALB',
    name: 'Albania',
    countryCodeNumber: '+355',
    code: 'AL',
  },
  {
    name: 'Algeria',
    countryCodeNumber: '+213',
    code: 'DZ',
  },
  {
    name: 'American Samoa',
    countryCodeNumber: '+1684',
    code: 'AS',
  },
  {
    name: 'Andorra',
    countryCodeNumber: '+376',
    code: 'AD',
  },
  {
    name: 'Angola',
    countryCodeNumber: '+244',
    code: 'AO',
  },
  {
    name: 'Anguilla',
    countryCodeNumber: '+1264',
    code: 'AI',
  },
  {
    name: 'Antarctica',
    countryCodeNumber: '+672',
    code: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    countryCodeNumber: '+1268',
    code: 'AG',
  },
  {
    name: 'Argentina',
    countryCodeNumber: '+54',
    code: 'AR',
  },
  {
    name: 'Armenia',
    countryCodeNumber: '+374',
    code: 'AM',
  },
  {
    name: 'Aruba',
    countryCodeNumber: '+297',
    code: 'AW',
  },
  {
    name: 'Australia',
    countryCodeNumber: '+61',
    code: 'AU',
  },
  {
    name: 'Austria',
    countryCodeNumber: '+43',
    code: 'AT',
  },
  {
    name: 'Azerbaijan',
    countryCodeNumber: '+994',
    code: 'AZ',
  },
  {
    name: 'Bahamas',
    countryCodeNumber: '+1242',
    code: 'BS',
  },
  {
    name: 'Bahrain',
    countryCodeNumber: '+973',
    code: 'BH',
  },
  {
    name: 'Bangladesh',
    countryCodeNumber: '+880',
    code: 'BD',
  },
  {
    name: 'Barbados',
    countryCodeNumber: '+1246',
    code: 'BB',
  },
  {
    name: 'Belarus',
    countryCodeNumber: '+375',
    code: 'BY',
  },
  {
    name: 'Belgium',
    countryCodeNumber: '+32',
    code: 'BE',
  },
  {
    name: 'Belize',
    countryCodeNumber: '+501',
    code: 'BZ',
  },
  {
    name: 'Benin',
    countryCodeNumber: '+229',
    code: 'BJ',
  },
  {
    name: 'Bermuda',
    countryCodeNumber: '+1441',
    code: 'BM',
  },
  {
    name: 'Bhutan',
    countryCodeNumber: '+975',
    code: 'BT',
  },
  {
    name: 'Bolivia',
    countryCodeNumber: '+591',
    code: 'BO',
  },
  {
    name: 'Bosnia and Herzegovina',
    countryCodeNumber: '+387',
    code: 'BA',
  },
  {
    name: 'Botswana',
    countryCodeNumber: '+267',
    code: 'BW',
  },
  {
    name: 'Brazil',
    countryCodeNumber: '+55',
    code: 'BR',
  },
  {
    name: 'British Indian Ocean Territory',
    countryCodeNumber: '+246',
    code: 'IO',
  },
  {
    name: 'Brunei',
    countryCodeNumber: '+673',
    code: 'BN',
  },
  {
    name: 'Bulgaria',
    countryCodeNumber: '+359',
    code: 'BG',
  },
  {
    name: 'Burkina Faso',
    countryCodeNumber: '+226',
    code: 'BF',
  },
  {
    name: 'Burundi',
    countryCodeNumber: '+257',
    code: 'BI',
  },
  {
    name: 'Cambodia',
    countryCodeNumber: '+855',
    code: 'KH',
  },
  {
    name: 'Cameroon',
    countryCodeNumber: '+237',
    code: 'CM',
  },
  {
    name: 'Canada',
    countryCodeNumber: '+1',
    code: 'CA',
  },
  {
    name: 'Cape Verde',
    countryCodeNumber: '+238',
    code: 'CV',
  },
  {
    name: 'Cayman Islands',
    countryCodeNumber: '+1345',
    code: 'KY',
  },
  {
    name: 'Central African Republic',
    countryCodeNumber: '+236',
    code: 'CF',
  },
  {
    name: 'Chad',
    countryCodeNumber: '+235',
    code: 'TD',
  },
  {
    name: 'Chile',
    countryCodeNumber: '+56',
    code: 'CL',
  },
  {
    name: 'China',
    countryCodeNumber: '+86',
    code: 'CN',
  },
  {
    name: 'Christmas Island',
    countryCodeNumber: '+61',
    code: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands',
    countryCodeNumber: '+61',
    code: 'CC',
  },
  {
    name: 'Colombia',
    countryCodeNumber: '+57',
    code: 'CO',
  },
  {
    name: 'Comoros',
    countryCodeNumber: '+269',
    code: 'KM',
  },
  {
    name: 'Congo',
    countryCodeNumber: '+242',
    code: 'CG',
  },
  {
    name: 'Republic of the Congo',
    countryCodeNumber: '+243',
    code: 'CD',
  },
  {
    name: 'Cook Islands',
    countryCodeNumber: '+682',
    code: 'CK',
  },
  {
    name: 'Costa Rica',
    countryCodeNumber: '+506',
    code: 'CR',
  },
  {
    name: 'Ivory Coast',
    countryCodeNumber: '+225',
    code: 'CI',
  },
  {
    name: 'Croatia',
    countryCodeNumber: '+385',
    code: 'HR',
  },
  {
    name: 'Cuba',
    countryCodeNumber: '+53',
    code: 'CU',
  },
  {
    name: 'Cyprus',
    countryCodeNumber: '+357',
    code: 'CY',
  },
  {
    name: 'Czech Republic',
    countryCodeNumber: '+420',
    code: 'CZ',
  },
  {
    name: 'Denmark',
    countryCodeNumber: '+45',
    code: 'DK',
  },
  {
    name: 'Djibouti',
    countryCodeNumber: '+253',
    code: 'DJ',
  },
  {
    name: 'Dominica',
    countryCodeNumber: '+1767',
    code: 'DM',
  },
  {
    name: 'Dominican Republic',
    countryCodeNumber: '+1809',
    code: 'DO',
  },
  {
    name: 'Dominican Republic',
    countryCodeNumber: '+1829',
    code: 'DO',
  },
  {
    name: 'Dominican Republic',
    countryCodeNumber: '+1849',
    code: 'DO',
  },
  {
    name: 'Ecuador',
    countryCodeNumber: '+593',
    code: 'EC',
  },
  {
    name: 'Egypt',
    countryCodeNumber: '+20',
    code: 'EG',
  },
  {
    name: 'El Salvador',
    countryCodeNumber: '+503',
    code: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    countryCodeNumber: '+240',
    code: 'GQ',
  },
  {
    name: 'Eritrea',
    countryCodeNumber: '+291',
    code: 'ER',
  },
  {
    name: 'Estonia',
    countryCodeNumber: '+372',
    code: 'EE',
  },
  {
    name: 'Ethiopia',
    countryCodeNumber: '+251',
    code: 'ET',
  },
  {
    name: 'Falkland Islands',
    countryCodeNumber: '+500',
    code: 'FK',
  },
  {
    name: 'Faroe Islands',
    countryCodeNumber: '+298',
    code: 'FO',
  },
  {
    name: 'Fiji',
    countryCodeNumber: '+679',
    code: 'FJ',
  },
  {
    name: 'Finland',
    countryCodeNumber: '+358',
    code: 'FI',
  },
  {
    name: 'France',
    countryCodeNumber: '+33',
    code: 'FR',
  },
  {
    name: 'French Guiana',
    countryCodeNumber: '+594',
    code: 'GF',
  },
  {
    name: 'French Polynesia',
    countryCodeNumber: '+689',
    code: 'PF',
  },
  {
    name: 'Gabon',
    countryCodeNumber: '+241',
    code: 'GA',
  },
  {
    name: 'Gambia',
    countryCodeNumber: '+220',
    code: 'GM',
  },
  {
    name: 'Georgia',
    countryCodeNumber: '+995',
    code: 'GE',
  },
  {
    name: 'Germany',
    countryCodeNumber: '+49',
    code: 'DE',
  },
  {
    name: 'Ghana',
    countryCodeNumber: '+233',
    code: 'GH',
  },
  {
    name: 'Gibraltar',
    countryCodeNumber: '+350',
    code: 'GI',
  },
  {
    name: 'Greece',
    countryCodeNumber: '+30',
    code: 'GR',
  },
  {
    name: 'Greenland',
    countryCodeNumber: '+299',
    code: 'GL',
  },
  {
    name: 'Grenada',
    countryCodeNumber: '+1473',
    code: 'GD',
  },
  {
    name: 'Guadeloupe',
    countryCodeNumber: '+590',
    code: 'GP',
  },
  {
    name: 'Guam',
    countryCodeNumber: '+1671',
    code: 'GU',
  },
  {
    name: 'Guatemala',
    countryCodeNumber: '+502',
    code: 'GT',
  },
  {
    name: 'Guernsey',
    countryCodeNumber: '+44',
    code: 'GG',
  },
  {
    name: 'Guinea',
    countryCodeNumber: '+224',
    code: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    countryCodeNumber: '+245',
    code: 'GW',
  },
  {
    name: 'Guyana',
    countryCodeNumber: '+592',
    code: 'GY',
  },
  {
    name: 'Haiti',
    countryCodeNumber: '+509',
    code: 'HT',
  },
  {
    name: 'Holy See (Vatican City)',
    countryCodeNumber: '+379',
    code: 'VA',
  },
  {
    name: 'Honduras',
    countryCodeNumber: '+504',
    code: 'HN',
  },
  {
    name: 'Hong Kong',
    countryCodeNumber: '+852',
    code: 'HK',
  },
  {
    name: 'Hungary',
    countryCodeNumber: '+36',
    code: 'HU',
  },
  {
    name: 'Iceland',
    countryCodeNumber: '+354',
    code: 'IS',
  },
  {
    name: 'India',
    countryCodeNumber: '+91',
    code: 'IN',
  },
  {
    name: 'Indonesia',
    countryCodeNumber: '+62',
    code: 'ID',
  },
  {
    name: 'Iran',
    countryCodeNumber: '+98',
    code: 'IR',
  },
  {
    name: 'Iraq',
    countryCodeNumber: '+964',
    code: 'IQ',
  },
  {
    name: 'Ireland',
    countryCodeNumber: '+353',
    code: 'IE',
  },
  {
    name: 'Isle of Man',
    countryCodeNumber: '+44',
    code: 'IM',
  },
  {
    name: 'Israel',
    countryCodeNumber: '+972',
    code: 'IL',
  },
  {
    name: 'Italy',
    countryCodeNumber: '+39',
    code: 'IT',
  },
  {
    name: 'Jamaica',
    countryCodeNumber: '+1876',
    code: 'JM',
  },
  {
    name: 'Jamaica',
    countryCodeNumber: '+1658',
    code: 'JM',
  },
  {
    name: 'Japan',
    countryCodeNumber: '+81',
    code: 'JP',
  },
  {
    name: 'Jersey',
    countryCodeNumber: '+44',
    code: 'JE',
  },
  {
    name: 'Jordan',
    countryCodeNumber: '+962',
    code: 'JO',
  },
  {
    name: 'Kazakhstan',
    countryCodeNumber: '+77',
    code: 'KZ',
  },
  {
    name: 'Kenya',
    countryCodeNumber: '+254',
    code: 'KE',
  },
  {
    name: 'Kiribati',
    countryCodeNumber: '+686',
    code: 'KI',
  },
  {
    name: 'North Korea',
    countryCodeNumber: '+850',
    code: 'KP',
  },
  {
    name: 'South Korea',
    countryCodeNumber: '+82',
    code: 'KR',
  },
  {
    name: 'Kuwait',
    countryCodeNumber: '+965',
    code: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    countryCodeNumber: '+996',
    code: 'KG',
  },
  {
    name: 'Laos',
    countryCodeNumber: '+856',
    code: 'LA',
  },
  {
    name: 'Latvia',
    countryCodeNumber: '+371',
    code: 'LV',
  },
  {
    name: 'Lebanon',
    countryCodeNumber: '+961',
    code: 'LB',
  },
  {
    name: 'Lesotho',
    countryCodeNumber: '+266',
    code: 'LS',
  },
  {
    name: 'Liberia',
    countryCodeNumber: '+231',
    code: 'LR',
  },
  {
    name: 'Libya',
    countryCodeNumber: '+218',
    code: 'LY',
  },
  {
    name: 'Liechtenstein',
    countryCodeNumber: '+423',
    code: 'LI',
  },
  {
    name: 'Lithuania',
    countryCodeNumber: '+370',
    code: 'LT',
  },
  {
    name: 'Luxembourg',
    countryCodeNumber: '+352',
    code: 'LU',
  },
  {
    name: 'Macau',
    countryCodeNumber: '+853',
    code: 'MO',
  },
  {
    name: 'Macedonia',
    countryCodeNumber: '+389',
    code: 'MK',
  },
  {
    name: 'Madagascar',
    countryCodeNumber: '+261',
    code: 'MG',
  },
  {
    name: 'Malawi',
    countryCodeNumber: '+265',
    code: 'MW',
  },
  {
    name: 'Malaysia',
    countryCodeNumber: '+60',
    code: 'MY',
  },
  {
    name: 'Maldives',
    countryCodeNumber: '+960',
    code: 'MV',
  },
  {
    name: 'Mali',
    countryCodeNumber: '+223',
    code: 'ML',
  },
  {
    name: 'Malta',
    countryCodeNumber: '+356',
    code: 'MT',
  },
  {
    name: 'Marshall Islands',
    countryCodeNumber: '+692',
    code: 'MH',
  },
  {
    name: 'Martinique',
    countryCodeNumber: '+596',
    code: 'MQ',
  },
  {
    name: 'Mauritania',
    countryCodeNumber: '+222',
    code: 'MR',
  },
  {
    name: 'Mauritius',
    countryCodeNumber: '+230',
    code: 'MU',
  },
  {
    name: 'Mayotte',
    countryCodeNumber: '+262',
    code: 'YT',
  },
  {
    name: 'Mexico',
    countryCodeNumber: '+52',
    code: 'MX',
  },
  {
    name: 'Micronesia',
    countryCodeNumber: '+691',
    code: 'FM',
  },
  {
    name: 'Moldova',
    countryCodeNumber: '+373',
    code: 'MD',
  },
  {
    name: 'Monaco',
    countryCodeNumber: '+377',
    code: 'MC',
  },
  {
    name: 'Mongolia',
    countryCodeNumber: '+976',
    code: 'MN',
  },
  {
    name: 'Montenegro',
    countryCodeNumber: '+382',
    code: 'ME',
  },
  {
    name: 'Montserrat',
    countryCodeNumber: '+1664',
    code: 'MS',
  },
  {
    name: 'Western Sahara',
    countryCodeNumber: '+212',
    code: 'EH',
  },
  {
    name: 'Morocco',
    countryCodeNumber: '+212',
    code: 'MA',
  },
  {
    name: 'Mozambique',
    countryCodeNumber: '+258',
    code: 'MZ',
  },
  {
    name: 'Burma (Myanmar)',
    countryCodeNumber: '+95',
    code: 'MM',
  },
  {
    name: 'Namibia',
    countryCodeNumber: '+264',
    code: 'NA',
  },
  {
    name: 'Nauru',
    countryCodeNumber: '+674',
    code: 'NR',
  },
  {
    name: 'Nepal',
    countryCodeNumber: '+977',
    code: 'NP',
  },
  {
    name: 'Netherlands',
    countryCodeNumber: '+31',
    code: 'NL',
  },
  {
    name: 'Netherlands Antilles',
    countryCodeNumber: '+599',
    code: 'AN',
  },
  {
    name: 'New Caledonia',
    countryCodeNumber: '+687',
    code: 'NC',
  },
  {
    name: 'New Zealand',
    countryCodeNumber: '+64',
    code: 'NZ',
  },
  {
    name: 'Nicaragua',
    countryCodeNumber: '+505',
    code: 'NI',
  },
  {
    name: 'Niger',
    countryCodeNumber: '+227',
    code: 'NE',
  },
  {
    name: 'Nigeria',
    countryCodeNumber: '+234',
    code: 'NG',
  },
  {
    name: 'Niue',
    countryCodeNumber: '+683',
    code: 'NU',
  },
  {
    name: 'Norfolk Island',
    countryCodeNumber: '+672',
    code: 'NF',
  },
  {
    name: 'Northern Mariana Islands',
    countryCodeNumber: '+1670',
    code: 'MP',
  },
  {
    name: 'Norway',
    countryCodeNumber: '+47',
    code: 'NO',
  },
  {
    name: 'Oman',
    countryCodeNumber: '+968',
    code: 'OM',
  },
  {
    name: 'Pakistan',
    countryCodeNumber: '+92',
    code: 'PK',
  },
  {
    name: 'Palau',
    countryCodeNumber: '+680',
    code: 'PW',
  },
  {
    name: 'State of Palestine',
    countryCodeNumber: '+970',
    code: 'PS',
  },
  {
    name: 'Panama',
    countryCodeNumber: '+507',
    code: 'PA',
  },
  {
    name: 'Papua New Guinea',
    countryCodeNumber: '+675',
    code: 'PG',
  },
  {
    name: 'Paraguay',
    countryCodeNumber: '+595',
    code: 'PY',
  },
  {
    name: 'Peru',
    countryCodeNumber: '+51',
    code: 'PE',
  },
  {
    name: 'Philippines',
    countryCodeNumber: '+63',
    code: 'PH',
  },
  {
    name: 'Pitcairn Islands',
    countryCodeNumber: '+872',
    code: 'PN',
  },
  {
    name: 'Poland',
    countryCodeNumber: '+48',
    code: 'PL',
  },
  {
    name: 'Portugal',
    countryCodeNumber: '+351',
    code: 'PT',
  },
  {
    name: 'Puerto Rico',
    countryCodeNumber: '+1939',
    code: 'PR',
  },
  {
    name: 'Puerto Rico',
    countryCodeNumber: '+1787',
    code: 'PR',
  },
  {
    name: 'Qatar',
    countryCodeNumber: '+974',
    code: 'QA',
  },
  {
    name: 'Romania',
    countryCodeNumber: '+40',
    code: 'RO',
  },
  {
    name: 'Russia',
    countryCodeNumber: '+7',
    code: 'RU',
  },
  {
    name: 'Rwanda',
    countryCodeNumber: '+250',
    code: 'RW',
  },
  {
    name: 'Reunion',
    countryCodeNumber: '+262',
    code: 'RE',
  },
  {
    name: 'Saint Barthelemy',
    countryCodeNumber: '+590',
    code: 'BL',
  },
  {
    name: 'Saint Helena',
    countryCodeNumber: '+290',
    code: 'SH',
  },
  {
    name: 'Saint Kitts and Nevis',
    countryCodeNumber: '+1869',
    code: 'KN',
  },
  {
    name: 'Saint Lucia',
    countryCodeNumber: '+1758',
    code: 'LC',
  },
  {
    name: 'Saint Martin',
    countryCodeNumber: '+590',
    code: 'MF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    countryCodeNumber: '+508',
    code: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    countryCodeNumber: '+1784',
    code: 'VC',
  },
  {
    name: 'Samoa',
    countryCodeNumber: '+685',
    code: 'WS',
  },
  {
    name: 'San Marino',
    countryCodeNumber: '+378',
    code: 'SM',
  },
  {
    name: 'Sao Tome and Principe',
    countryCodeNumber: '+239',
    code: 'ST',
  },
  {
    name: 'Saudi Arabia',
    countryCodeNumber: '+966',
    code: 'SA',
  },
  {
    name: 'Senegal',
    countryCodeNumber: '+221',
    code: 'SN',
  },
  {
    name: 'Serbia',
    countryCodeNumber: '+381',
    code: 'RS',
  },
  {
    name: 'Seychelles',
    countryCodeNumber: '+248',
    code: 'SC',
  },
  {
    name: 'Sierra Leone',
    countryCodeNumber: '+232',
    code: 'SL',
  },
  {
    name: 'Singapore',
    countryCodeNumber: '+65',
    code: 'SG',
  },
  {
    name: 'Slovakia',
    countryCodeNumber: '+421',
    code: 'SK',
  },
  {
    name: 'Slovenia',
    countryCodeNumber: '+386',
    code: 'SI',
  },
  {
    name: 'Solomon Islands',
    countryCodeNumber: '+677',
    code: 'SB',
  },
  {
    name: 'Somalia',
    countryCodeNumber: '+252',
    code: 'SO',
  },
  {
    name: 'South Africa',
    countryCodeNumber: '+27',
    code: 'ZA',
  },
  {
    name: 'South Sudan',
    countryCodeNumber: '+211',
    code: 'SS',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    countryCodeNumber: '+500',
    code: 'GS',
  },
  {
    name: 'Spain',
    countryCodeNumber: '+34',
    code: 'ES',
  },
  {
    name: 'Sri Lanka',
    countryCodeNumber: '+94',
    code: 'LK',
  },
  {
    name: 'Sudan',
    countryCodeNumber: '+249',
    code: 'SD',
  },
  {
    name: 'Suriname',
    countryCodeNumber: '+597',
    code: 'SR',
  },
  {
    name: 'Svalbard',
    countryCodeNumber: '+47',
    code: 'SJ',
  },
  {
    name: 'Swaziland',
    countryCodeNumber: '+268',
    code: 'SZ',
  },
  {
    name: 'Sweden',
    countryCodeNumber: '+46',
    code: 'SE',
  },
  {
    name: 'Switzerland',
    countryCodeNumber: '+41',
    code: 'CH',
  },
  {
    name: 'Syria',
    countryCodeNumber: '+963',
    code: 'SY',
  },
  {
    name: 'Taiwan',
    countryCodeNumber: '+886',
    code: 'TW',
  },
  {
    name: 'Tajikistan',
    countryCodeNumber: '+992',
    code: 'TJ',
  },
  {
    name: 'Tanzania',
    countryCodeNumber: '+255',
    code: 'TZ',
  },
  {
    name: 'Thailand',
    countryCodeNumber: '+66',
    code: 'TH',
  },
  {
    name: 'Timor-Leste',
    countryCodeNumber: '+670',
    code: 'TL',
  },
  {
    name: 'Togo',
    countryCodeNumber: '+228',
    code: 'TG',
  },
  {
    name: 'Tokelau',
    countryCodeNumber: '+690',
    code: 'TK',
  },
  {
    name: 'Tonga',
    countryCodeNumber: '+676',
    code: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    countryCodeNumber: '+1868',
    code: 'TT',
  },
  {
    name: 'Tunisia',
    countryCodeNumber: '+216',
    code: 'TN',
  },
  {
    name: 'Turkey',
    countryCodeNumber: '+90',
    code: 'TR',
  },
  {
    name: 'Turkmenistan',
    countryCodeNumber: '+993',
    code: 'TM',
  },
  {
    name: 'Turks and Caicos Islands',
    countryCodeNumber: '+1649',
    code: 'TC',
  },
  {
    name: 'Tuvalu',
    countryCodeNumber: '+688',
    code: 'TV',
  },
  {
    name: 'Uganda',
    countryCodeNumber: '+256',
    code: 'UG',
  },
  {
    name: 'Ukraine',
    countryCodeNumber: '+380',
    code: 'UA',
  },
  {
    name: 'United Arab Emirates',
    countryCodeNumber: '+971',
    code: 'AE',
  },
  {
    name: 'United Kingdom',
    countryCodeNumber: '+44',
    code: 'GB',
  },
  {
    name: 'United States',
    countryCodeNumber: '+1',
    code: 'US',
  },
  {
    name: 'Uruguay',
    countryCodeNumber: '+598',
    code: 'UY',
  },
  {
    name: 'Uzbekistan',
    countryCodeNumber: '+998',
    code: 'UZ',
  },
  {
    name: 'Vanuatu',
    countryCodeNumber: '+678',
    code: 'VU',
  },
  {
    name: 'Venezuela',
    countryCodeNumber: '+58',
    code: 'VE',
  },
  {
    name: 'Vietnam',
    countryCodeNumber: '+84',
    code: 'VN',
  },
  {
    name: 'British Virgin Islands',
    countryCodeNumber: '+1284',
    code: 'VG',
  },
  {
    name: 'US Virgin Islands',
    countryCodeNumber: '+1340',
    code: 'VI',
  },
  {
    name: 'Wallis and Futuna',
    countryCodeNumber: '+681',
    code: 'WF',
  },
  {
    name: 'Yemen',
    countryCodeNumber: '+967',
    code: 'YE',
  },
  {
    name: 'Zambia',
    countryCodeNumber: '+260',
    code: 'ZM',
  },
  {
    name: 'Zimbabwe',
    countryCodeNumber: '+263',
    code: 'ZW',
  },
  {
    id: 'GAZ',
    name: 'Gaza Strip',
    countryCodeNumber: '+970',
    code: 'PS',
  },
  {
    id: 'XKX',
    name: 'Kosovo',
    countryCodeNumber: '+383',
  },
  {
    id: 'WEB',
    name: 'West Bank',
    countryCodeNumber: null,
  },
]
